import { render, staticRenderFns } from "./holidaySetting.vue?vue&type=template&id=fb3ab7c6&scoped=true"
import script from "./holidaySetting.vue?vue&type=script&lang=js"
export * from "./holidaySetting.vue?vue&type=script&lang=js"
import style0 from "./holidaySetting.vue?vue&type=style&index=0&id=fb3ab7c6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3ab7c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb3ab7c6')) {
      api.createRecord('fb3ab7c6', component.options)
    } else {
      api.reload('fb3ab7c6', component.options)
    }
    module.hot.accept("./holidaySetting.vue?vue&type=template&id=fb3ab7c6&scoped=true", function () {
      api.rerender('fb3ab7c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/hr/holidaySetting.vue"
export default component.exports